import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TenureFilter extends Component {
    state = {
         tenureLists:[],
         tenureValue:'',
    };
    componentDidMount(){
        this._getTenure(this.props.start_date,this.props.end_date);
    }

    resetTenureFilter(){
        this.setState({
        tenureValue: [],
        })
    }
     _getTenure(start_date, end_date){
        axios.post(config.get('API_URL')+'/reports/emi-debit-card-tenure/',{
                yestSend:start_date,
                todSend:end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    tenureLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((Tenure, index) => {
                    this.state.tenureLists.push({value: Tenure.tenure, label: Tenure.tenure})
                });
            }
        });
    }
    changeTenure(optionSelected){
        let value='';
        let tenureArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenureArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                tenureArray.push(mids.value)
            });
        }
        this.props.onSelectTenure(optionSelected, tenureArray);
        this.setState({
            tenureValue:optionSelected,

        });
    }

    render() {

        return (
            <ReactMultiSelectCheckboxes name="tenure"
                                isMulti
            value={this.state.tenureValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeTenure.bind(this)}
            options={this.state.tenureLists}
            placeholderButtonLabel="Select [Tenure]"
        />
        );

    }
}
export default TenureFilter;